<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
    <form [formGroup]="losForm" (ngSubmit)="onSubmit()">
      <h1 *ngIf="source !== 'modal'" class="heading">
        {{losId ? 'Edit' : 'Add'}}
      </h1>
      <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2">
        <div class="space-y-1">
          <label class="subheading">
            Title <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="title" type="text" />
            </div>
            <div *ngIf="submitted && form.title.errors">
              <p *ngIf="form.title.errors.required" class="pt-1 text-red-600 text-xs">
                Title is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            Status
          </label>
          <div>
            <div>
              <select formControlName="isActive">
                <option [value]="true">Active</option>
                <option [value]="false">Inactive</option>
              </select>
            </div>
            <div *ngIf="submitted && form.isActive.errors">
              <p *ngIf="form.isActive.errors.required" class="pt-1 text-red-600 text-xs">
                Status is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            Description <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <textarea formControlName="description" name="" class="h-16"></textarea>
            </div>
            <div *ngIf="submitted && form.description.errors">
              <p *ngIf="form.description.errors.required" class="pt-1 text-red-600 text-xs">
                Description is required
              </p>
            </div>
          </div>
        </div>
        <div></div>
        <!-- Vehicle Image -->
        <div class="relative overflow-hidden rounded-full mt-1 w-32 h-32 border border-main-base">
          <img *ngIf="profileImageURL"
            [src]="profileImageURL"
            alt="Profile Image"
            class="h-full w-full rounded-full object-cover" />
        
          <svg *ngIf="!profileImageURL" xmlns="http://www.w3.org/2000/svg"
            class="w-full h-full p-4 dark:text-white rounded-full"
            viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M6 19v1q0 .425-.288.713T5 21H4q-.425 0-.712-.288T3 20v-8l2.1-6q.15-.45.538-.725T6.5 5h11q.475 0 .863.275T18.9 6l2.1 6v8q0 .425-.287.713T20 21h-1q-.425 0-.712-.288T18 20v-1zm-.2-9h12.4l-1.05-3H6.85zM5 12v5zm2.5 4q.625 0 1.063-.437T9 14.5t-.437-1.062T7.5 13t-1.062.438T6 14.5t.438 1.063T7.5 16m9 0q.625 0 1.063-.437T18 14.5t-.437-1.062T16.5 13t-1.062.438T15 14.5t.438 1.063T16.5 16M5 17h14v-5H5z" />
          </svg>
        
          <label for="Profile"
            class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100 transition-opacity duration-300">
            <span>Change</span>
            <input #logoInput type="file" accept="image/*"
              (change)="processFile(logoInput)"
              id="Profile"
              name="Profile Image"
              class="absolute inset-0 w-full h-full cursor-pointer rounded-full opacity-0" />
          </label>
        </div>
        
      </section>
      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="flex justify-end gap-4">
        <button type="submit" class="btn btn-secondary">
          {{losId ? 'Update' : 'Create'}}
        </button>
      </section>
    </form>
  </div>

</section>